import { render, staticRenderFns } from "./CustomSection.vue?vue&type=template&id=fe510c3c&scoped=true"
import script from "./CustomSection.vue?vue&type=script&lang=js"
export * from "./CustomSection.vue?vue&type=script&lang=js"
import style0 from "./CustomSection.vue?vue&type=style&index=0&id=fe510c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe510c3c",
  null
  
)

export default component.exports